<template>
  <div class="hero-bubbles">
    <div
      v-for="(hero, index) in heroes"
      :key="hero.id"
      ref="slotEls"
      :class="[
        'hero-slot',
        `hero-slot-${index + 1}`,
        hero.position === 'left' ? 'hero-slot--hoverable' : '',
        displayIndex === index ? 'is-active' : '',
      ]"
      @mouseenter="handleHeroMouseEnter(hero, index)"
      @mouseleave="handleHeroMouseLeave(hero)"
    >
      <div
        class="hero-dodge"
        :style="dodgeStyle(index)"
      >
        <div
          :class="[
            'hero-circle',
            displayIndex === index ? 'active' : '',
          ]"
          :style="{ backgroundImage: `url(${hero.image})` }"
        />
        <svg
          class="hero-name-ring"
          :class="{ active: displayIndex === index }"
          viewBox="0 0 120 120"
        >
          <path
            :id="`hero-name-path-${hero.id}`"
            d="M 8,60 A 52,52 0 0 1 112,60"
            fill="none"
          />
          <text class="hero-name-text">
            <textPath
              :href="`#hero-name-path-${hero.id}`"
              startOffset="50%"
              text-anchor="middle"
            >{{ hero.name }}</textPath>
          </text>
        </svg>
        <Transition name="hero-bubble-pop">
          <div
            v-if="displayIndex === index"
            :class="[
              'hero-speech-bubble',
              hero.side === 'right' ? 'hero-speech-bubble--right' : 'hero-speech-bubble--left',
            ]"
            :style="bubbleTextStyle(heroPhrase(hero))"
          >
            {{ heroPhrase(hero) }}
            <div class="hero-speech-bubble-tail" />
          </div>
        </Transition>
      </div>
    </div>
  </div>
</template>

<script>
import heroImage2 from '@/assets/images/bubble_heroes/2.webp'
import heroImage3 from '@/assets/images/bubble_heroes/3.webp'
import heroImage4 from '@/assets/images/bubble_heroes/4.webp'
import heroImage5 from '@/assets/images/bubble_heroes/5.webp'
import heroImage6 from '@/assets/images/bubble_heroes/6.webp'
import heroImage7 from '@/assets/images/bubble_heroes/7.webp'
import heroImage8 from '@/assets/images/bubble_heroes/8.webp'
import heroImage9 from '@/assets/images/bubble_heroes/9.webp'
import heroImage10 from '@/assets/images/bubble_heroes/10.webp'
import heroImage11 from '@/assets/images/bubble_heroes/11.webp'
import heroImage12 from '@/assets/images/bubble_heroes/12.webp'
import heroImage13 from '@/assets/images/bubble_heroes/13.webp'
import heroImage14 from '@/assets/images/bubble_heroes/14.webp'

const ACTIVE_DURATION = 3000
const CYCLE_DURATION = 4000
const INITIAL_DELAY = 1000

const FLEE_RADIUS = 90
const FLEE_MAX_PUSH = 55
const FLEE_EDGE_MARGIN = 6

const HERO_COUNT = 13
const NARROW_VIEWPORT_MAX = 600

export default {
  name: 'ContentSectionStableCoinExplanationHeroBubbles',
  data: () => ({
    heroes: [
      { id: 2, image: heroImage2, side: 'left', position: 'right', name: getContent('section_stablecoin_explanation.hero_2_name'), phrase: getContent('section_stablecoin_explanation.hero_2_phrase') },
      { id: 3, image: heroImage3, side: 'right', position: 'left', name: getContent('section_stablecoin_explanation.hero_3_name'), phrase: getContent('section_stablecoin_explanation.hero_3_phrase') },
      { id: 4, image: heroImage4, side: 'left', position: 'right', name: getContent('section_stablecoin_explanation.hero_4_name'), phrase: getContent('section_stablecoin_explanation.hero_4_phrase') },
      { id: 5, image: heroImage5, side: 'right', position: 'left', name: getContent('section_stablecoin_explanation.hero_5_name'), phrase: getContent('section_stablecoin_explanation.hero_5_phrase') },
      { id: 6, image: heroImage6, side: 'left', position: 'right', name: getContent('section_stablecoin_explanation.hero_6_name'), phrase: getContent('section_stablecoin_explanation.hero_6_phrase') },
      { id: 7, image: heroImage7, side: 'right', position: 'left', name: getContent('section_stablecoin_explanation.hero_7_name'), phrase: getContent('section_stablecoin_explanation.hero_7_phrase') },
      { id: 8, image: heroImage8, side: 'left', position: 'right', name: getContent('section_stablecoin_explanation.hero_8_name'), phrase: getContent('section_stablecoin_explanation.hero_8_phrase') },
      { id: 9, image: heroImage9, side: 'right', position: 'left', name: getContent('section_stablecoin_explanation.hero_9_name'), phrase: getContent('section_stablecoin_explanation.hero_9_phrase') },
      { id: 10, image: heroImage10, side: 'left', position: 'right', name: getContent('section_stablecoin_explanation.hero_10_name'), phrase: getContent('section_stablecoin_explanation.hero_10_phrase') },
      { id: 11, image: heroImage11, side: 'right', position: 'left', name: getContent('section_stablecoin_explanation.hero_11_name'), phrase: getContent('section_stablecoin_explanation.hero_11_phrase') },
      { id: 12, image: heroImage12, side: 'left', position: 'right', name: getContent('section_stablecoin_explanation.hero_12_name'), phrase: getContent('section_stablecoin_explanation.hero_12_phrase') },
      { id: 13, image: heroImage13, side: 'right', position: 'left', name: getContent('section_stablecoin_explanation.hero_13_name'), phrase: getContent('section_stablecoin_explanation.hero_13_phrase') },
      { id: 14, image: heroImage14, side: 'left', position: 'right', name: getContent('section_stablecoin_explanation.hero_14_name'), phrase: getContent('section_stablecoin_explanation.hero_14_phrase') },
    ],
    cycleOrder: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    activeIndex: -1,
    hoveredIndex: -1,
    cyclePosition: 0,
    activationTimer: null,
    deactivationTimer: null,
    dodgeOffsets: Array.from({ length: HERO_COUNT }, () => ({ x: 0, y: 0 })),
    dodgeFleeing: Array.from({ length: HERO_COUNT }, () => false),
    viewportWidth: 0,
    pendingPauseResolve: null,
  }),
  props: {
    paused: { type: Boolean, default: false },
  },
  computed: {
    displayIndex () {
      return this.hoveredIndex !== -1 ? this.hoveredIndex : this.activeIndex
    },
  },
  watch: {
    paused (isPaused) {
      if (isPaused) {
        this.pauseCycle()
      } else {
        this.resumeCycle()
      }
    },
  },
  mounted() {
    if (!this.paused) {
      this.activationTimer = setTimeout(this.runCycle, INITIAL_DELAY)
    }
    this.viewportWidth = window.innerWidth
    window.addEventListener('mousemove', this.handleFleeMouseMove, { passive: true })
    window.addEventListener('resize', this.handleViewportResize, { passive: true })
  },
  beforeUnmount() {
    clearTimeout(this.activationTimer)
    clearTimeout(this.deactivationTimer)
    window.removeEventListener('mousemove', this.handleFleeMouseMove)
    window.removeEventListener('resize', this.handleViewportResize)
  },
  methods: {
    heroPhrase(hero) {
      return hero.phrase
    },
    handleViewportResize() {
      this.viewportWidth = window.innerWidth
    },
    bubbleTextStyle(phrase) {
      let fontSize = 14

      if (this.viewportWidth > 0 && this.viewportWidth <= NARROW_VIEWPORT_MAX) {
        const length = phrase?.length || 0
        if (length > 90) fontSize = 5
        else if (length > 76) fontSize = 5.5
        else if (length > 64) fontSize = 6.5
        else if (length > 57) fontSize = 8
        else if (length > 49) fontSize = 9
        else if (length > 35) fontSize = 11
      }

      return {
        fontSize: `${fontSize}px`,
        lineHeight: `${Math.round(fontSize * (16 / 14) * 100) / 100}px`,
      }
    },
    runCycle() {
      const position = this.cyclePosition
      this.activeIndex = this.cycleOrder[position]

      this.deactivationTimer = setTimeout(() => {
        this.activeIndex = -1
        if (this.pendingPauseResolve) {
          this.pendingPauseResolve()
          this.pendingPauseResolve = null
        }
      }, ACTIVE_DURATION)

      this.cyclePosition = (position + 1) % this.cycleOrder.length

      this.activationTimer = setTimeout(this.runCycle, CYCLE_DURATION)
    },
    pauseCycle() {
      clearTimeout(this.activationTimer)
      if (this.activeIndex === -1) {
        clearTimeout(this.deactivationTimer)
      }
    },
    resumeCycle() {
      this.activationTimer = setTimeout(this.runCycle, 300)
    },
    requestPause() {
      clearTimeout(this.activationTimer)

      return new Promise((resolve) => {
        if (this.activeIndex === -1) {
          resolve()
          return
        }
        this.pendingPauseResolve = resolve
      })
    },
    handleHeroMouseEnter(hero, index) {
      if (hero.position === 'left') {
        this.hoveredIndex = index
      }
    },
    handleHeroMouseLeave(hero) {
      if (hero.position === 'left') {
        this.hoveredIndex = -1
      }
    },
    dodgeStyle(index) {
      const offset = this.dodgeOffsets[index]
      if (!offset || (offset.x === 0 && offset.y === 0)) return null
      return {
        transform: `translate(${offset.x}px, ${offset.y}px)`,
        transitionDuration: this.dodgeFleeing[index] ? '.3s' : '1.4s',
      }
    },
    handleFleeMouseMove(event) {
      const slots = this.$refs.slotEls
      if (!slots) return

      this.heroes.forEach((hero, index) => {
        if (hero.position !== 'right') return

        const el = slots[index]
        if (!el) return

        const rect = el.getBoundingClientRect()
        const centerX = rect.left + rect.width / 2
        const centerY = rect.top + rect.height / 2

        const dx = centerX - event.clientX
        const dy = centerY - event.clientY
        const distance = Math.hypot(dx, dy)

        let offsetX = 0
        let offsetY = 0

        if (distance < FLEE_RADIUS) {
          const dirX = distance < 1 ? 0 : dx / distance
          const dirY = distance < 1 ? -1 : dy / distance
          const strength = (1 - distance / FLEE_RADIUS) * FLEE_MAX_PUSH

          offsetX = dirX * strength
          offsetY = dirY * strength

          if (rect.left + offsetX < FLEE_EDGE_MARGIN) {
            offsetX = FLEE_EDGE_MARGIN - rect.left
          }
          if (rect.right + offsetX > window.innerWidth - FLEE_EDGE_MARGIN) {
            offsetX = window.innerWidth - FLEE_EDGE_MARGIN - rect.right
          }
        }

        this.dodgeOffsets[index].x = offsetX
        this.dodgeOffsets[index].y = offsetY
        this.dodgeFleeing[index] = distance < FLEE_RADIUS
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.hero-bubbles {
  position: absolute;
  top: 0;
  left: 50%;
  width: 100vw;
  margin-left: -50vw;
  height: 205px;
  user-select: none;
}

.hero-slot {
  position: absolute;
  z-index: 0;
  transition: opacity .8s ease;
}

.hero-slot--hoverable {
  z-index: 1;
}

.hero-slot.is-active {
  animation-play-state: paused;
  opacity: 1;
  z-index: 20;
}

.hero-dodge {
  position: relative;
  transition: transform 1.4s ease-out;
}

.hero-circle {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: $black;
  background-size: cover;
  background-position: center;
  border: 2px solid $yellow-100;
  transform: scale(0.667);
  transition: transform .35s ease, border-width .25s ease, box-shadow .25s ease;

  &.active {
    transform: scale(1);
    border-width: 4px;
    box-shadow: 0 0 24px rgba(255, 231, 141, 0.6);
  }
}

.hero-name-ring {
  position: absolute;
  top: 48px;
  left: 48px;
  width: 130px;
  height: 130px;
  overflow: visible;
  transform: translate(-50%, -50%);
  opacity: 0;
  pointer-events: none;
  transition: opacity .35s ease;

  &.active {
    opacity: 1;
  }
}

.hero-name-text {
  fill: $yellow-200;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: .5px;
  text-transform: uppercase;
  paint-order: stroke;
  stroke: $black;
  stroke-width: 3px;
  stroke-linejoin: round;
}

.hero-speech-bubble {
  position: absolute;
  top: 64%;
  white-space: nowrap;
  padding: 8px 16px;
  border-radius: 20px;
  background-color: $yellow-200;
  color: $black;
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  z-index: 3;
  pointer-events: none;
  transform: translateY(-50%);
}

.hero-speech-bubble-tail {
  position: absolute;
  bottom: -14px;
  width: 20px;
  height: 24px;
  background-color: $yellow-200;
  -webkit-mask-image: url('@/assets/images/speach_tile.svg');
  mask-image: url('@/assets/images/speach_tile.svg');
  -webkit-mask-size: contain;
  mask-size: contain;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
}

.hero-speech-bubble--right {
  left: 76%;

  .hero-speech-bubble-tail {
    left: -2px;
    bottom: -4px;
    transform: rotate(4deg);
    transform-origin: top right;
  }
}

.hero-speech-bubble--left {
  right: 76%;

  .hero-speech-bubble-tail {
    right: -21px;
    bottom: 0;
    transform: scaleX(-1) rotate(13deg);
    transform-origin: top left;
  }
}

.hero-bubble-pop-enter-active {
  transition: opacity .25s ease, transform .25s cubic-bezier(.34, 1.56, .64, 1);
  transition-delay: .1s;
}
.hero-bubble-pop-leave-active {
  transition: opacity .2s ease, transform .2s ease;
}
.hero-bubble-pop-enter-from {
  opacity: 0;
  transform: translateY(-50%) scale(.3);
}
.hero-bubble-pop-leave-to {
  opacity: 0;
  transform: translateY(-50%) scale(.6);
}
.hero-speech-bubble--right.hero-bubble-pop-enter-from,
.hero-speech-bubble--right.hero-bubble-pop-leave-to {
  transform-origin: left center;
}
.hero-speech-bubble--left.hero-bubble-pop-enter-from,
.hero-speech-bubble--left.hero-bubble-pop-leave-to {
  transform-origin: right center;
}

@keyframes bubble-float-1 {
  0%    { transform: translate(4vw, 0px) scale(1); opacity: 1; }
  12.5% { transform: translate(2.8vw, 1.84vw) scale(.99); opacity: .98; }
  25%   { transform: translate(0px, 2.56vw) scale(.97); opacity: .96; }
  37.5% { transform: translate(-2.8vw, 1.84vw) scale(.95); opacity: .94; }
  50%   { transform: translate(-4vw, 0px) scale(.94); opacity: .93; }
  62.5% { transform: translate(-2.8vw, -1.84vw) scale(.95); opacity: .94; }
  75%   { transform: translate(0px, -2.56vw) scale(.97); opacity: .96; }
  87.5% { transform: translate(2.8vw, -1.84vw) scale(.99); opacity: .98; }
  100%  { transform: translate(4vw, 0px) scale(1); opacity: 1; }
}
@keyframes bubble-float-2 {
  0%    { transform: translate(65px, 0px) scale(1); opacity: 1; }
  12.5% { transform: translate(46px, -39px) scale(.99); opacity: .98; }
  25%   { transform: translate(0px, -55px) scale(.97); opacity: .96; }
  37.5% { transform: translate(-46px, -39px) scale(.95); opacity: .94; }
  50%   { transform: translate(-65px, 0px) scale(.94); opacity: .93; }
  62.5% { transform: translate(-46px, 39px) scale(.95); opacity: .94; }
  75%   { transform: translate(0px, 55px) scale(.97); opacity: .96; }
  87.5% { transform: translate(46px, 39px) scale(.99); opacity: .98; }
  100%  { transform: translate(65px, 0px) scale(1); opacity: 1; }
}
@keyframes bubble-float-3 {
  0%    { transform: translate(5vw, 0px) scale(1); opacity: 1; }
  12.5% { transform: translate(3.55vw, 1.91vw) scale(.99); opacity: .98; }
  25%   { transform: translate(0px, 2.64vw) scale(.97); opacity: .96; }
  37.5% { transform: translate(-3.55vw, 1.91vw) scale(.95); opacity: .94; }
  50%   { transform: translate(-5vw, 0px) scale(.94); opacity: .93; }
  62.5% { transform: translate(-3.55vw, -1.91vw) scale(.95); opacity: .94; }
  75%   { transform: translate(0px, -2.64vw) scale(.97); opacity: .96; }
  87.5% { transform: translate(3.55vw, -1.91vw) scale(.99); opacity: .98; }
  100%  { transform: translate(5vw, 0px) scale(1); opacity: 1; }
}
@keyframes bubble-float-4 {
  0%    { transform: translate(60px, 0px) scale(1); opacity: 1; }
  12.5% { transform: translate(42px, -35px) scale(.99); opacity: .98; }
  25%   { transform: translate(0px, -50px) scale(.97); opacity: .96; }
  37.5% { transform: translate(-42px, -35px) scale(.95); opacity: .94; }
  50%   { transform: translate(-60px, 0px) scale(.94); opacity: .93; }
  62.5% { transform: translate(-42px, 35px) scale(.95); opacity: .94; }
  75%   { transform: translate(0px, 50px) scale(.97); opacity: .96; }
  87.5% { transform: translate(42px, 35px) scale(.99); opacity: .98; }
  100%  { transform: translate(60px, 0px) scale(1); opacity: 1; }
}
@keyframes bubble-float-5 {
  0%    { transform: translate(4vw, 0px) scale(1); opacity: 1; }
  12.5% { transform: translate(2.8vw, -1.84vw) scale(.99); opacity: .98; }
  25%   { transform: translate(0px, -2.56vw) scale(.97); opacity: .96; }
  37.5% { transform: translate(-2.8vw, -1.84vw) scale(.95); opacity: .94; }
  50%   { transform: translate(-4vw, 0px) scale(.94); opacity: .93; }
  62.5% { transform: translate(-2.8vw, 1.84vw) scale(.95); opacity: .94; }
  75%   { transform: translate(0px, 2.56vw) scale(.97); opacity: .96; }
  87.5% { transform: translate(2.8vw, 1.84vw) scale(.99); opacity: .98; }
  100%  { transform: translate(4vw, 0px) scale(1); opacity: 1; }
}
@keyframes bubble-float-6 {
  0%    { transform: translate(65px, 0px) scale(1); opacity: 1; }
  12.5% { transform: translate(46px, 39px) scale(.99); opacity: .98; }
  25%   { transform: translate(0px, 55px) scale(.97); opacity: .96; }
  37.5% { transform: translate(-46px, 39px) scale(.95); opacity: .94; }
  50%   { transform: translate(-65px, 0px) scale(.94); opacity: .93; }
  62.5% { transform: translate(-46px, -39px) scale(.95); opacity: .94; }
  75%   { transform: translate(0px, -55px) scale(.97); opacity: .96; }
  87.5% { transform: translate(46px, -39px) scale(.99); opacity: .98; }
  100%  { transform: translate(65px, 0px) scale(1); opacity: 1; }
}
@keyframes bubble-float-7 {
  0%    { transform: translate(5vw, 0px) scale(1); opacity: 1; }
  12.5% { transform: translate(3.55vw, -1.91vw) scale(.99); opacity: .98; }
  25%   { transform: translate(0px, -2.64vw) scale(.97); opacity: .96; }
  37.5% { transform: translate(-3.55vw, -1.91vw) scale(.95); opacity: .94; }
  50%   { transform: translate(-5vw, 0px) scale(.94); opacity: .93; }
  62.5% { transform: translate(-3.55vw, 1.91vw) scale(.95); opacity: .94; }
  75%   { transform: translate(0px, 2.64vw) scale(.97); opacity: .96; }
  87.5% { transform: translate(3.55vw, 1.91vw) scale(.99); opacity: .98; }
  100%  { transform: translate(5vw, 0px) scale(1); opacity: 1; }
}
@keyframes bubble-float-8 {
  0%    { transform: translate(60px, 0px) scale(1); opacity: 1; }
  12.5% { transform: translate(42px, 35px) scale(.99); opacity: .98; }
  25%   { transform: translate(0px, 50px) scale(.97); opacity: .96; }
  37.5% { transform: translate(-42px, 35px) scale(.95); opacity: .94; }
  50%   { transform: translate(-60px, 0px) scale(.94); opacity: .93; }
  62.5% { transform: translate(-42px, -35px) scale(.95); opacity: .94; }
  75%   { transform: translate(0px, -50px) scale(.97); opacity: .96; }
  87.5% { transform: translate(42px, -35px) scale(.99); opacity: .98; }
  100%  { transform: translate(60px, 0px) scale(1); opacity: 1; }
}

.hero-slot-1 {
  top: 2%;
  right: 5%;
  animation: bubble-float-1 7s linear -2s infinite;
}
.hero-slot-2 {
  top: 2%;
  left: 8%;
  animation: bubble-float-8 9s linear -6s infinite;
}
.hero-slot-3 {
  top: 16%;
  right: 15%;
  animation: bubble-float-2 8s linear -13s infinite;
}
.hero-slot-4 {
  top: 16%;
  left: 17%;
  animation: bubble-float-1 7s linear -7s infinite;
}
.hero-slot-5 {
  top: 30%;
  right: 4%;
  animation: bubble-float-3 6s linear -5s infinite;
}
.hero-slot-6 {
  top: 30%;
  left: 5%;
  animation: bubble-float-2 8s linear -1s infinite;
}
.hero-slot-7 {
  top: 44%;
  right: 17%;
  animation: bubble-float-4 9s linear -17s infinite;
}
.hero-slot-8 {
  top: 44%;
  left: 15%;
  animation: bubble-float-3 6s linear -11s infinite;
}
.hero-slot-9 {
  top: 58%;
  right: 6%;
  animation: bubble-float-5 6s linear -9s infinite;
}
.hero-slot-10 {
  top: 58%;
  left: 4%;
  animation: bubble-float-4 9s linear -4s infinite;
}
.hero-slot-11 {
  top: 72%;
  right: 14%;
  animation: bubble-float-6 8s linear -3s infinite;
}
.hero-slot-12 {
  top: 72%;
  left: 16%;
  animation: bubble-float-5 6s linear -14s infinite;
}
.hero-slot-13 {
  top: 86%;
  right: 8%;
  animation: bubble-float-7 5s linear -10s infinite;
}

.hero-slot-2 .hero-circle,
.hero-slot-4 .hero-circle,
.hero-slot-6 .hero-circle,
.hero-slot-8 .hero-circle,
.hero-slot-10 .hero-circle,
.hero-slot-12 .hero-circle {
  cursor: pointer;
}

@media only screen and (max-width: $md) {
  .hero-bubbles {
    height: 175px;
  }
}

@media only screen and (max-width: $sm) {
  .hero-bubbles {
    height: 135px;
  }
  .hero-circle {
    width: 72px;
    height: 72px;
    transform: scale(0.667);

    &.active {
      transform: scale(1);
      border-width: 3px;
    }
  }
  .hero-name-ring {
    top: 36px;
    left: 36px;
    width: 97px;
    height: 97px;
  }
  .hero-speech-bubble {
    padding: 8px 12px;
  }

  @keyframes bubble-float-2 {
    0%    { transform: translate(36px, 0px) scale(1); opacity: 1; }
    12.5% { transform: translate(25px, -21px) scale(.99); opacity: .98; }
    25%   { transform: translate(0px, -30px) scale(.97); opacity: .96; }
    37.5% { transform: translate(-25px, -21px) scale(.95); opacity: .94; }
    50%   { transform: translate(-36px, 0px) scale(.94); opacity: .93; }
    62.5% { transform: translate(-25px, 21px) scale(.95); opacity: .94; }
    75%   { transform: translate(0px, 30px) scale(.97); opacity: .96; }
    87.5% { transform: translate(25px, 21px) scale(.99); opacity: .98; }
    100%  { transform: translate(36px, 0px) scale(1); opacity: 1; }
  }
  @keyframes bubble-float-4 {
    0%    { transform: translate(33px, 0px) scale(1); opacity: 1; }
    12.5% { transform: translate(23px, -20px) scale(.99); opacity: .98; }
    25%   { transform: translate(0px, -28px) scale(.97); opacity: .96; }
    37.5% { transform: translate(-23px, -20px) scale(.95); opacity: .94; }
    50%   { transform: translate(-33px, 0px) scale(.94); opacity: .93; }
    62.5% { transform: translate(-23px, 20px) scale(.95); opacity: .94; }
    75%   { transform: translate(0px, 28px) scale(.97); opacity: .96; }
    87.5% { transform: translate(23px, 20px) scale(.99); opacity: .98; }
    100%  { transform: translate(33px, 0px) scale(1); opacity: 1; }
  }
  @keyframes bubble-float-6 {
    0%    { transform: translate(36px, 0px) scale(1); opacity: 1; }
    12.5% { transform: translate(25px, 21px) scale(.99); opacity: .98; }
    25%   { transform: translate(0px, 30px) scale(.97); opacity: .96; }
    37.5% { transform: translate(-25px, 21px) scale(.95); opacity: .94; }
    50%   { transform: translate(-36px, 0px) scale(.94); opacity: .93; }
    62.5% { transform: translate(-25px, -21px) scale(.95); opacity: .94; }
    75%   { transform: translate(0px, -30px) scale(.97); opacity: .96; }
    87.5% { transform: translate(25px, -21px) scale(.99); opacity: .98; }
    100%  { transform: translate(36px, 0px) scale(1); opacity: 1; }
  }
  @keyframes bubble-float-8 {
    0%    { transform: translate(33px, 0px) scale(1); opacity: 1; }
    12.5% { transform: translate(23px, 20px) scale(.99); opacity: .98; }
    25%   { transform: translate(0px, 28px) scale(.97); opacity: .96; }
    37.5% { transform: translate(-23px, 20px) scale(.95); opacity: .94; }
    50%   { transform: translate(-33px, 0px) scale(.94); opacity: .93; }
    62.5% { transform: translate(-23px, -20px) scale(.95); opacity: .94; }
    75%   { transform: translate(0px, -28px) scale(.97); opacity: .96; }
    87.5% { transform: translate(23px, -20px) scale(.99); opacity: .98; }
    100%  { transform: translate(33px, 0px) scale(1); opacity: 1; }
  }
}

@media only screen and (max-width: $xs) {
  .hero-bubbles {
    height: 110px;
  }
  .hero-slot-1 {
    top: 2%;
  }
  .hero-slot-2 {
    top: 2%;
  }
  .hero-slot-3 {
    top: 11%;
  }
  .hero-slot-4 {
    top: 13%;
  }
  .hero-slot-5 {
    top: 21%;
  }
  .hero-slot-6 {
    top: 24%;
  }
  .hero-slot-7 {
    top: 30%;
  }
  .hero-slot-8 {
    top: 36%;
  }
  .hero-slot-9 {
    top: 39%;
  }
  .hero-slot-10 {
    top: 47%;
  }
  .hero-slot-11 {
    top: 49%;
  }
  .hero-slot-12 {
    top: 58%;
  }
  .hero-slot-13 {
    top: 58%;
  }
  .hero-circle {
    width: 56px;
    height: 56px;
    border-width: 1.5px;
    transform: scale(0.643);

    &.active {
      transform: scale(1);
      border-width: 3px;
    }
  }
  .hero-name-ring {
    top: 28px;
    left: 28px;
    width: 76px;
    height: 76px;
  }
  .hero-speech-bubble {
    padding: 6px 10px;
    border-radius: 14px;
  }
  .hero-speech-bubble--right {
    .hero-speech-bubble-tail {
      width: 12px;
      height: 21px;
    }
  }
  .hero-speech-bubble--left {
    .hero-speech-bubble-tail {
      width: 14px;
      height: 16px;
    }
  }
  .hero-speech-bubble--left .hero-speech-bubble-tail {
    right: -14px;
    bottom: 2px;
    transform: scaleX(-1) rotate(16deg);
  }
}
</style>
